import React from "react";
import { Helmet } from "react-helmet";
const EcommerceHelmet = ({ title }) => {
  return (
    <Helmet>
      <title>
        Custom Ecommerce Development Services in USA
      </title>
      <meta
        name="description"
        content="Boost online sales with leading custom ecommerce development services in USA. Contact us today for scalable, SEO-driven, high-performing stores."
      />
    </Helmet>
  );
};

export default EcommerceHelmet;
